import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { viewEmployeeSalary } from "../../http";
import { toast } from "react-toastify";
import Loading from "../Loading";

const Salary = () => {
  const { user } = useSelector((state) => state.authSlice);
  const [salary, setSalary] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await viewEmployeeSalary({ employeeID: user.id });
        const { data } = res;
        if (data.length > 0) {
          setSalary(data[0]);
        } else {
          toast.error(`${user.name}'s salary not found`);
        }
      } catch (error) {
        toast.error("Error fetching salary data");
      }
    };

    if (user?.id) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [user?.id]);

  // Calculate earned salary (sum of all allowances)
  const calculateEarnedSalary = () => {
    if (!salary) return 0;
    return (
      salary.basic +
      salary.hra +
      salary.medicalAllowance +
      salary.conveyanceAllowance +
      salary.bookAllowance +
      salary.specialPeriodicAllowance +
      salary.employerPf +
      salary.pli
    );
  };

  const calculateDeduction = () => {
    if (!salary) return 0;
    return salary.totalDeduction ;
  };

  // Calculate net salary (earned - deductions)
  const calculateNetSalary = () => {
    const earned = calculateEarnedSalary();
    const totalDe = calculateDeduction();
    const payableSalary = earned - totalDe || 0;
    return payableSalary;
  };

  return (
    <>
      {salary ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4>Salary Details</h4>
              </div>
            </div>

            <div className="card">
              <div className="card-body row">
                <div className="col-md-3">
                  <img
                    className="img-fluid img-thumbnail"
                    src={user.image}
                    alt=""
                  />
                </div>
                <div className="col-md-9">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <td>{user.name}</td>
                      </tr>
                      <tr>
                        <th>Email</th>
                        <td>{user.email}</td>
                      </tr>
                      <tr>
                        <th>Mobile</th>
                        <td>{user.mobile}</td>
                      </tr>
                      <tr>
                        <th>Address</th>
                        <td>{user.address}</td>
                      </tr>
                      <tr>
                        <th>Earned Salary</th>
                        <td>Rs. {calculateEarnedSalary()}</td>
                      </tr>
                      <tr>
                        <th>Total Deduction</th>
                        <td>Rs. {salary?.totalDeduction || 0}</td>
                      </tr>
                      <tr>
                        <th>Net Salary</th>
                        <td>Rs. {calculateNetSalary()}</td>
                      </tr>
                      <tr>
                        <th>Total Leaves</th>
                        <td>{salary?.totalLeaves || 0}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Salary;
